// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Login_wrapper__3cAfi","log-in-button":"Login_log-in-button__1kFWk","box-link":"Login_box-link__1B0k7","logo":"Login_logo__qnOWm"};